import React, { ReactElement } from 'react'
import { ArtData } from '@/database/art'
import BaseWalletDetails from '@/components/wallets/BaseWalletDetails'

const WalletsOverview = ({ artData }: { artData: ArtData | undefined }): ReactElement => {
    const personalWallet = artData?.art?.nft?.personalWallet
    const vaultWallet = artData?.art?.nft?.vaultWallet

    return (
        <div className="wallets-overview bottom">
            <div className="bottom">
                {vaultWallet && (
                    <BaseWalletDetails
                        wallet={vaultWallet}
                        title="VAULT WALLET"
                        controller={'(The DAO controls this wallet)'}
                    />
                )}
            </div>
            {personalWallet && (
                <BaseWalletDetails
                    wallet={personalWallet}
                    title="PERSONAL WALLET"
                    controller={'(You control this wallet)'}
                />
            )}
        </div>
    )
}

export default WalletsOverview
